export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8532.18e2183d.jpg";